import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  AvatarConfig,
  AvatarTokenConfig,
  AvatarType,
} from "@models/avatar-config";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";
import { ListResponse } from "@models/list-response";
import { Voice } from "@models/voice";
import { Avatar } from "@models/avatar";

const BASE_API_URL = process.env.REACT_APP_API_URL;

export const avatarApi = createApi({
  reducerPath: "avatarApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API_URL,
    prepareHeaders: prepareAuthHeaders,
  }),
  endpoints: (builder) => ({
    getConfig: builder.query<AvatarConfig, string>({
      query: (sessionId: string) => ({
        url: "/avatar/config",
        method: "GET",
        params: { sessionId },
      }),
    }),
    getAvatars: builder.query<ListResponse<Avatar>, void>({
      query: () => {
        return {
          url: "/avatar",
          method: "GET",
        };
      },
    }),
    getVoices: builder.query<ListResponse<Voice>, void>({
      query: () => {
        return {
          url: "/avatar/voices",
          method: "GET",
        };
      },
    }),
    getToken: builder.query<AvatarTokenConfig, { provider: AvatarType }>({
      query: (params) => {
        return {
          url: "/avatar/token",
          method: "GET",
          params,
        };
      },
    }),
  }),
});

export const {
  useGetConfigQuery,
  useGetAvatarsQuery,
  useGetVoicesQuery,
  useGetTokenQuery,
} = avatarApi;
